let _uid = 0;

function uid() {
  return _uid++;
}

export default {
  inserted(el, binding) {
    const prefix = binding.value || '';

    el.id = prefix + '-' + uid();
  }
};
